import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { applyTimeZone, RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import { createPaginatedSchema, ShiftListItem, shiftListItemSchema } from '../types';

export type OriginalShiftRegistryParams = {
	page?: number;
	limit?: number;
	dateFrom?: string;
	dateTo?: string;
	timeZone?: number;
	personal?: boolean;
};

export type ShiftRegistryFilters = {
	dateFrom: string;
	dateTo: string;
	timeZone: number;
	personal: boolean;
};

export type ShiftRegistryParams = RegistryParams<ShiftRegistryFilters>;

export type ShiftRegistryQuery = RegistryQuery<
	ShiftListItem,
	ShiftRegistryFilters,
	JsonApiRequestError
>;

export const createShiftRegistryQuery = (): ShiftRegistryQuery =>
	createAuthQuery({
		params: declareParams<ShiftRegistryParams>(),
		request: {
			method: 'GET',
			url: '/shift/list',
			query: (params) => ({
				page: params.page,
				limit: params.limit,
				dateFrom: params.filters.dateFrom,
				dateTo: params.filters.dateTo,
				timeZone: params.filters.timeZone,
				personal: params.filters.personal,
			}),
		},
		response: {
			contract: zodContract(createPaginatedSchema(shiftListItemSchema)),
			mapData: ({ result, params }) => ({
				...result,
				rows: result.rows.map((row) => ({
					...row,
					startTime: applyTimeZone(row.startTime, params.filters.timeZone),
					endTime: row.endTime && applyTimeZone(row.endTime, params.filters.timeZone),
				})),
			}),
		},
	});
